angular
	.module 'App.Repository'
	.factory 'RenderRepository',
	[
		'$window', '$q', 'BaseRepository', 'LanguageService',
		($window, $q, BaseRepository, LanguageService) ->
			class RenderRepository extends BaseRepository
				@resource = '/render'
				@isRestricted = true

				download: (model, id, type = 'pdf', action = 'render', query = null, locale = null) ->
					return @downloadFromUrl(@getRenderUrl(model, id, type, action, query, locale))

				###
				Pass arguments one by one or as object in first argument:
				getRenderUrl('orders', 'O-123', 'html', 'render', null, 'lt')
				getRenderUrl({model: 'orders', id: 'O-123', type: 'html', locale: 'lt'})
				###
				getRenderUrl: (model, id, type = 'pdf', action = 'render', query = null, locale = null) ->
					data =
						model: model
						id: id
						type: type
						action: action
						query: query
						locale: locale

					if _.isObject(model)
						for parameter, value of model
							data[parameter] = value

					data.locale ?= LanguageService.getDisplayLanguage().language

					return @toString(data.query, @getUrlString(data.model, data.id, data.action, data.type, data.locale), '')

				#
				# @deprecated - endpoint should be re-written to Twig and than use @getRenderUrl
				#
				getDownloadUrl: (model, id = null, type = 'pdf', query = null) ->
					if type == 'pdf'
						query ?= new Query()
						query.parameters.lang = LanguageService.getDisplayLanguage().language

					if model == 'sales_report'
						if type == 'pdf'
							return @toString(query, 'downloadpdf', '/')
						else
							return @toString(query, 'downloadcsv', '/')

					return @toString(query, @getResourceUrl(model, id, type))

				getData: (model, id, type = 'json', query = null) ->
					@findByQuery(query, @getResourceUrl(model, id, type))

				getResourceUrl: (model, id, type = 'pdf') ->
					return @getUrlString type, model, id

				getUrlString: (...parts) ->
					return '/' + parts.filter((x) => x?).join('/')

				downloadFromUrl: (url) ->
					$window.open url, '_blank'

					return $q.when true

			return new RenderRepository
	]
